var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 236 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-371-332H909V974H-371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    fillRule: "nonzero",
    d: "M165.765 67.928c-.829.58-2.205.771-3.766.774-.638 1.04-2.342 1.353-4.349 1.353-2.554 0-4.624-.499-4.624-2.366 0 0-.017-.188.007-.448-12.811-.589-27.852-1.026-41.643-1.245-5.22 3.615-12.457 5.598-21.648 5.598-9.47 0-16.52-2.587-21.446-5.476-14.305.291-29.335.794-41.467 1.441-.73.874-2.334 1.143-4.202 1.143l.078-.912-.086.005c-.08 1.777-2.113 2.26-4.616 2.26-2.176 0-3.994-.365-4.488-1.626-7.117.588-11.547 1.245-11.547 1.938 0 2.502 57.502 4.53 91.28 4.53s90.913-2.028 90.913-4.53c0-.898-7.378-1.735-18.396-2.439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.3,
    fillRule: "nonzero",
    d: "M170.008 70.327c0 .734-4.989 1.328-11.142 1.328s-11.143-.594-11.143-1.328c0-.733 4.99-1.327 11.143-1.327 6.153 0 11.142.594 11.142 1.327m-60.15 2.311c0 .688-8.732 1.246-19.503 1.246s-19.504-.558-19.504-1.246 8.733-1.246 19.504-1.246 19.503.558 19.503 1.246m-77.536-2.311c0 .734-4.988 1.328-11.141 1.328s-11.143-.594-11.143-1.328c0-.733 4.99-1.327 11.143-1.327 6.153 0 11.142.594 11.142 1.327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.507 58.326v4.69c2.133.302 3.744 1.674 3.744 3.32 0 1.868-2.07 2.367-4.624 2.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.507 58.326v4.69c2.133.302 3.744 1.674 3.744 3.32 0 1.868-2.07 2.367-4.624 2.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M71.545 37.964H18.002s-7.665-.59-10.123.944c-2.458 1.535-3.168-4.054-2.376-6.843.79-2.789-8.202 5.002-1.298 13.19 0 0-2.66 13.535 9.745 12.353v8.336c-.681.596-.572 1.745-.572 1.745 0 1.867 2.07 2.366 4.624 2.366 2.553 0 4.624-.499 4.624-2.366 0-1.648-1.61-3.02-3.745-3.32v-6.074h67.438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M162.845 57.957v5.06c2.133.3 3.745 1.673 3.745 3.32 0 1.867-2.07 2.366-4.625 2.366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M162.845 57.957v5.06c2.133.3 3.745 1.673 3.745 3.32 0 1.867-2.07 2.366-4.625 2.366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M118.998 57.958h34.6v7.987c-.68.596-.572 1.744-.572 1.744 0 1.868 2.07 2.367 4.624 2.367 2.553 0 4.623-.5 4.623-2.367 0-1.647-1.61-3.02-3.744-3.32v-6.411h8.543m-45.285-19.994h42.922M91.638 59.683c-13.538-2.51-18.32-19.507-20.093-22.142 0 0-2.039-5.679-3.477-.293"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M86.776 25.206s6.559-9.345 18.375-4.465c0 0 15.389 5.65 16.14 22.865.75 17.216-10.1 27.988-31.548 27.988-21.45 0-30.505-13.268-30.505-13.268"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M81.083 58.295s20.314 5.711 25.007-6.04c4.112-10.295-1.086-17.409-4.152-14.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M57.067 37.79s4.075-13.666 15.285-15.62c11.21-1.957 17.942 8.767 21.943 13.099 3.209 3.471 10.857 3.266 10.857 3.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF94CA",
    d: "M169.307 58.855c-.915.363-1.92-.116-2.234-1.066l-6.299-19.08c-.314-.95.177-2.025 1.092-2.388l5.355-2.128c.915-.363 1.921.116 2.234 1.066l6.3 19.079c.313.951-.179 2.026-1.094 2.389l-5.354 2.128z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M174.662 56.727l-5.355 2.128c-.915.363-1.92-.116-2.234-1.066l-6.299-19.08c-.314-.95.177-2.025 1.092-2.388l5.355-2.128c.915-.363 1.921.116 2.234 1.066l6.3 19.079c.313.951-.179 2.026-1.094 2.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M167.752 42.292c.149.414-.082.88-.518 1.038-.436.16-.91-.048-1.061-.462-.15-.414.082-.879.518-1.038.435-.159.91.048 1.06.462m-2.315-2.053c.15.414-.08.879-.517 1.038-.435.159-.911-.048-1.06-.462-.15-.414.081-.88.517-1.038.435-.16.91.048 1.06.462m2.894-1.151c.15.414-.082.88-.518 1.038-.435.16-.91-.047-1.06-.462-.15-.414.081-.879.518-1.038.435-.159.91.048 1.06.462m-1.158 6.408c.15.414-.08.88-.517 1.038-.435.16-.911-.047-1.06-.462-.15-.414.081-.879.517-1.038.435-.158.91.049 1.06.462m2.894-1.15c.15.414-.082.88-.518 1.038-.435.16-.91-.047-1.06-.46-.15-.416.081-.88.517-1.039.436-.16.912.047 1.061.461m-.579 3.204c.15.414-.081.88-.517 1.038-.436.16-.91-.048-1.061-.462-.15-.414.082-.879.518-1.038.435-.159.91.048 1.06.462m-.579 3.204c.15.414-.081.88-.517 1.038-.435.16-.91-.048-1.06-.462-.15-.414.08-.879.517-1.038.435-.159.91.048 1.06.462m2.894-1.15c.15.414-.082.879-.518 1.038-.435.159-.91-.047-1.06-.461-.149-.414.082-.879.517-1.038.436-.159.912.047 1.061.461m-.579 3.204c.15.414-.081.88-.518 1.038-.435.16-.91-.048-1.06-.462-.15-.414.081-.879.518-1.038.435-.159.91.048 1.06.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0046AA",
    d: "M174.68 56.729a2.709 2.709 0 01-.985 3.689 2.683 2.683 0 01-3.675-.988c-.743-1.292-.302-2.944.985-3.69s2.932-.303 3.675.989"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M174.68 56.729a2.709 2.709 0 01-.985 3.689 2.683 2.683 0 01-3.675-.988c-.743-1.292-.302-2.944.985-3.69s2.932-.303 3.675.989z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M179.496 52.755a32.982 32.982 0 01-3.922 2.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M207.782 17.939c1.23 1.24 1.252 3.412.048 4.849-1.204 1.436-3.179 1.595-4.41.354-1.23-1.24-1.253-3.411-.048-4.848 1.204-1.437 3.18-1.595 4.41-.355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M187.963 29.974l1.053-1.296m-9.624-.86c.359-.314.65-.575.847-.765 1.22-1.176 2.354-2.52 3.783-3.45 2.564-1.666 5.6-1.078 8.407-.504 1.701.348 3.57.82 5.302.405 1.617-.388 2.605-1.605 3.858-2.593 2.118-1.67 4.838-1.518 6.114 1.092 1.431 2.925 1.287 3.936-.731 5.987l-1.363 1.29c1.952 2.268-.067 3.26-2.176 4.792-3.88 2.816-15.826 15.692-17.584 16.39m-16.19-14.586c.78-.649 2.824-2.309 4.93-4.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M179.494 27.728s-8.6-2.331-3.026 11.983c5.165 13.264 1.3 23.495 7.63 17.331 4.29-4.176-.103-27.006-4.604-29.314z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C31B6C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M234.612 19.038L223.364 21m5.276-13.978l-8.595 7.965m-5.35-4.32h0L215.532 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDog);
export default __webpack_public_path__ + "static/media/error-dog.52be253c.svg";
export { ForwardRef as ReactComponent };